var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2faff",
    d: "M9.5 24.5L9.5 1.5 21.793 1.5 27.5 7.207 27.5 24.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M21.586,2L27,7.414V24H10V2H21.586 M22,1H9v24h19V7L22,1L22,1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.5 7.5L21.5 1.5 21.793 1.5 27.5 7.207 27.5 7.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M22 2.414L26.586 7H22V2.414M22 1h-1v7h7V7L22 1 22 1zM13 10H24V11H13zM13 13H22V14H13zM13 16H24V17H13zM13 19H22V20H13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 28.5L2.5 5.5 14.793 5.5 20.5 11.207 20.5 28.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M14.586,6L20,11.414V28H3V6H14.586 M15,5H2v24h19V11L15,5L15,5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.5 11.5L14.5 5.5 14.793 5.5 20.5 11.207 20.5 11.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M15 6.414L19.586 11H15V6.414M15 5h-1v7h7v-1L15 5 15 5zM6 14H17V15H6zM6 17H15V18H6zM6 20H17V21H6zM6 23H15V24H6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoDocuments);
export default __webpack_public_path__ + "static/media/twoDocuments.c3043387a798dc2f9b06c0a9ee922dd5.svg";
export { ForwardRef as ReactComponent };